// export const baseurl = "http://10.121.214.142:8082";
// export const baseurl = "https://10.111.201.120/supplementarycard";
// export const baseurl = "http://10.111.200.43:8081/supplementarycard";    
// export const baseurl = "https://10.111.201.120/supplementarycard";

// export const baseurl = process.env.NODE_ENV ==="production" ? "https://suppcapp.jsbl.com/supplementarycard" : "https://10.111.201.120/supplementarycard";
// export const baseurl = "http://10.121.214.84:8086";
export const baseurl = "https://suppcapp.jsbl.com/supplementarycard";

export const supplmentcardUrl = "/sc/supplementary_card";
export const supplmentCardgetUrl = "/sc/supplementary_card";
export const supplmentCardgetStatusUrl = "/sc/supplementary_card/status";
export const termsConditionsUrl = "/sc/supplementary_card/terms";
